module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-footer', {
    staticClass: "blue white--text"
  }, [_c('div', {
    staticClass: "text-xs-center",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("2017 - 2021 | © IQVIA")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-722341cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/sections/Footer.vue
// module id = 440
// module chunks = 0